import gql from "graphql-tag";

export const updateCollection = gql`
  mutation updateCollection(
    $input: UpdateCollectionInput!) {
    updateCollection(input: $input) {
      project {
        id
        collections {
          id
          index
          name
          archived
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
          searchableFields {
            field
            model
          }
        }
      }
    }
  }
`;

export const updateCollectionOptions = {
  name: "updateCollection",
};
